import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumOrderServiceType, EnumOrderServiceTypeOption } from "./EnumOrderServiceType";
import UiGroup from "./UiGroup";

/**
 * 装货港-报关表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutReleaseTime extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 海关放行时间
     */
    ReleaseTime?: Date;
    /**
     * 是否查验
     */
    IsCheck?: boolean;
    /**
     * 委托书主键
     */
    OrderPoolId?: string;
    /**
     * 订单主键
     */
    OrderId?: string;
    /**
     * 
     */
    Service?: EnumOrderServiceType;
    /**
     * 报关/清关主键
     */
    OrderDepartureId?: string;
    /**
     * 场景
     */
    Scene?: string;
    /**
     * 第三方接口-回调数据-可查询的字段
     */
    QueryThreeApiProps?: string;
    /**
     * 第三方接口-回调数据-已绑定的字段
     */
    BindThreeApiProps?: string;
}

/**
 * 装货港-报关表单-表单校验
 */
export const DtoPutReleaseTimeRules = {
}

/**
 * 装货港-报关表单-设置项
 */
export const DtoPutReleaseTimeMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "ReleaseTime",
    Label: "海关放行时间",
    Customize: true,
  },
  {
    Prop: "Service",
    Label: "",
    Customize: true,
  },
]
